import React, { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import MaterialUi from "./MaterialUi";
import { ReactLoadingSkeletonAllProduct } from "./Skeleton";
import { MyContextSupply } from "../../../Context";
import "./allproduct.css";
import axios from "axios";
import { NavLink } from "react-router-dom";
import ShortDisplayReview from "../../ReviewRating/ShortDisplayReview";

const AllProductCategory = () => {
  const {
    handleAddProduct,
    setIsProductAddPopUpOpen,
    toggleRunPath,
    setSingleProductPathId,
  } = MyContextSupply();
  const [isProductLoading, setIsProductLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [whichCategory, setWhichCategory] = useState("");

  // console.log(allProducts);
  
  const fetchingCategoryItem = async () => {
    setIsProductLoading(true);
    return await axios
      .get(`https://stechbackend-9r4c.onrender.com/getproducts/${whichCategory}`)
      .then((res) => {
        if (res.status === 201) {
          setAllProducts(res.data);
          setIsProductLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchingCategoryItem();
  }, [whichCategory]);
  const setOnClickForCategory = (value) => {
    if (value === "all") {
      setWhichCategory("");
    } else {
      setWhichCategory(value);
    }
  };
  // console.log(allProducts);

  return (
    <section className="all-product-section">
      <div className="all-product-left">
        <div className="product-left-select-title-flex">
          {/* this mui component for select category buttons */}
          <MaterialUi
            className="pos-ma"
            whichCategory={whichCategory}
            setOnClickForCategory={setOnClickForCategory}
          />
        </div>
      </div>
      <div className="all-product-right">
        <div className="allproduct-flex">
          {isProductLoading ? (
            <>
              <ReactLoadingSkeletonAllProduct />
              <ReactLoadingSkeletonAllProduct />
              <ReactLoadingSkeletonAllProduct />
              <ReactLoadingSkeletonAllProduct />
              <ReactLoadingSkeletonAllProduct />
              <ReactLoadingSkeletonAllProduct />
            </>
          ) : (
            allProducts.map((prod) => {
              const {
                _id: id,
                url,
                price: { mrp, cost },
                title: { shortTitle },
                review,
              } = prod;
              // console.log(id);
              // calculating discount of product
              let discount = ((mrp - cost) / mrp) * 100;
              if (discount % 1 === 0) {
                discount = parseInt(discount);
              } else {
                discount = discount.toFixed(2);
              }
              return (
                <div key={id} className="allproducts">
                  <div className="img-ab-discount">
                    <img src={url} alt="" className="allproduct_img" onClick={() => console.log("hello")} />
                    {discount >= 25 && (
                      <div>
                        <LocalFireDepartmentIcon
                          className="m-discount-icon localFireDepartmentCicon"
                        />
                        <p className="p-di">{discount}%off</p>
                      </div>
                    )}
                  </div>
                  <div className="all-product-text">
                    <Divider />
                    <div className="product-title-and-review-flex">
                      <h3 className="products_name">
                        {shortTitle.slice(0, 7)}...
                      </h3>
                        <ShortDisplayReview review={review} fontSizeCustom={14}/>
                    </div>
                    <p>
                      <span className="main-price-span">${mrp}</span> ${cost}
                    </p>
                    <div className="button-all-product-flex">
                      <NavLink
                        to={`/getproductsone/${id}`}
                        className="navlink-all-product-btn"
                      >
                        <button
                          onClick={() => {
                            toggleRunPath();
                            setSingleProductPathId(id);
                          }}
                          className="btn-all-p-1-d"
                        >
                          Details
                        </button>
                      </NavLink>
                      <button
                        onClick={() => {
                          handleAddProduct(prod);
                          setIsProductAddPopUpOpen(true);
                        }}
                      >
                        Add to cart
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </section>
  );
};

export default AllProductCategory;
